import React from 'react';

class Login extends React.Component {

    getLoginUrl() {
        const { admin = false } = this.props;

        const userLoginUrl =  process.env.REACT_APP_USER_LOGIN_URL;
        const adminLoginUrl = process.env.REACT_APP_ADMIN_LOGIN_URL;

        if (admin && adminLoginUrl) {
            return adminLoginUrl;
        } else if (!admin && userLoginUrl) {
            return userLoginUrl;
        }
    }

    componentDidMount() {
        const loginUrl = this.getLoginUrl();

        if (window && window.location && loginUrl) {
            window.location = loginUrl;
        }
    }

    render() {
        return null;
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/session/Login.js